import React from "react";
import SkillCard from "./skill/skillCard";
import PageTitle from "../common/pageTitle";
import { MdDesignServices } from "react-icons/md";
import { FaCode, FaCloud, FaDatabase, FaMobileAlt } from "react-icons/fa";

function About() {
  const expertise = [
    {
      textOne: "Full Stack Development",
      icon: <FaCode className="fill-white mx-3 my-auto text-5xl" />,
      textTwo:
        "Building robust applications with React, Next.js, and T3 Stack.",
    },
    {
      textOne: "Mobile App Development",
      icon: <FaMobileAlt className="fill-white mx-3 my-auto text-5xl" />,
      textTwo: "High-performance mobile apps using Flutter",
    },
    {
      textOne: "UI/UX Design",
      icon: <MdDesignServices className="fill-white mx-3 my-auto text-5xl" />,
      textTwo: "Crafting intuitive user interfaces with modern design tools.",
    },
    {
      textOne: "Database Management",
      icon: <FaDatabase className="fill-white mx-3 my-auto text-5xl" />,
      textTwo: "Managing databases like MySQL, MongoDB, and PostgreSQL.",
    },
    {
      textOne: "Cloud Integration",
      icon: <FaCloud className="fill-white mx-3 my-auto text-5xl" />,
      textTwo:
        "Deploying and managing apps on cloud platforms like AWS & Firebase.",
    },
  ];

  return (
    <div className="my-5 px-5">
      <PageTitle title={"About"} />
      <p className="py-7 font-poppins text-gray-300">
        I'm currently pursuing a Master of Applied Computing at the University
        of Windsor, specializing in Artificial Intelligence. I'm also AWS
        certified ☁️ and deeply interested in working with cloud technologies.
        I've had the opportunity to work on a variety of projects, from building
        AI-driven apps 🤖 to optimizing user interfaces 🎨. My journey has taken
        me from startups like Tummo Labs 🚀 to large organizations like Tata
        Consultancy Services, where I've dived deep into both frontend and
        backend development 💻.
        <br />
        <br />
        I love tackling complex challenges 💡, whether it's resolving
        performance issues or enhancing the user experience. My toolkit includes
        Flutter, React, and a mix of other modern technologies ⚙️ that help me
        bring ideas to life.
        <br />
        <br />
        I’m now on the lookout for a co-op opportunity starting in May 2025! If
        you're looking for someone who's passionate about creating impactful
        software and ready to dive in, let's connect! 🌟
        <br />
      </p>
      <div className="text-white text-2xl font-poppins font-extrabold relative pb-1.5">
        My Expertise
      </div>
      <div className="block md:grid md:grid-cols-2 gap-x-6 gap-y-5 mt-5">
        {expertise.map((expert, index) => (
          <SkillCard
            key={index}
            icon={expert.icon}
            delay={index * 0.1}
            textOne={expert.textOne}
            textTwo={expert.textTwo}
          />
        ))}
      </div>
    </div>
  );
}

export default About;
